import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CaseDetailPage } from './case-detail.page';

const routes: Routes = [
  {
    path: '',
    component: CaseDetailPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes), TranslateModule],
  exports: [RouterModule],
})
export class CaseDetailPageRoutingModule {}
